import React, { useEffect, useState } from "react";
import { Autocomplete, Button, Dialog, DialogActions, DialogContent, DialogTitle, TextField } from "@mui/material";

// Elegir o escribir el nombre de una carpeta: «Mover a carpeta…» desde el menú de una tarjeta (lo que hace el arrastre,
// también en teléfono y con teclado) o «Nueva carpeta». Vacío significa «Sin agrupar».
const GroupDialog = ({ open, title, confirmLabel = "Mover", initialValue = "", options = [], allowEmpty = true, onClose, onConfirm }) => {
    const [value, setValue] = useState(initialValue);

    useEffect(() => {
        if (open) setValue(initialValue || "");
    }, [initialValue, open]);

    const trimmed = value.trim();
    const fieldProps = {
        autoFocus: true,
        margin: "dense",
        label: "Carpeta",
        helperText: allowEmpty ? "Déjalo vacío para dejarla en «Sin agrupar»." : undefined,
        onKeyDown: (event) => {
            if (event.key !== "Enter" || !(allowEmpty || trimmed)) return;
            event.preventDefault();
            event.stopPropagation();
            onConfirm(trimmed);
        },
    };

    return (
        <Dialog open={open} onClose={onClose} fullWidth maxWidth="xs">
            <DialogTitle>{title}</DialogTitle>
            <DialogContent>
                {options.length ? (
                    <Autocomplete
                        freeSolo
                        options={options}
                        inputValue={value}
                        onInputChange={(_event, next) => setValue(next || "")}
                        renderInput={(params) => <TextField {...params} {...fieldProps} />}
                    />
                ) : (
                    // Sin carpetas que sugerir, un campo simple: el autocompletado se queda con el primer Escape.
                    <TextField fullWidth value={value} onChange={(event) => setValue(event.target.value)} {...fieldProps} />
                )}
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose}>Cancelar</Button>
                <Button variant="contained" disabled={!allowEmpty && !trimmed} onClick={() => onConfirm(trimmed)}>{confirmLabel}</Button>
            </DialogActions>
        </Dialog>
    );
};

export default GroupDialog;
